/**
 * Created by Languagenut on 25/02/2020.
 */


var AssetLoader = (function(){

    var LOADING = false;
    var LOADED  = [];
    var FONTS = false;
    function AssetLoader(){

    }

    AssetLoader.prototype.getResource = function(key){
        return  window.PIXI.loader.resources[key];
    };

    AssetLoader.prototype.getTextureFromSheet = function(textureID){
        console.log(window.PIXI.loader.resources[textureID])
        return  window.PIXI.loader.resources[textureID].texture
    };

    AssetLoader.prototype.get = function(textureID) {
        return this.getTextureFromSheet(textureID);
    }

    AssetLoader.prototype.load = function(){
        var paths = arguments;
        var count = 0;
        if(paths.length == 0) return new Promise(function(resolve){resolve()});;



        return new Promise(function(resolve){

            ([].slice.apply(paths)).forEach((function(path){
                if(!LOADED.indexOf(path) >= 0){
                    count++;
                    delete ( window.PIXI.loader.resources[path]);  window.PIXI.loader.add(path)
                }

            }).bind(this));

            if(count == 0) return resolve();

            window.PIXI.loader.load();
            window.PIXI.loader.once('complete', resolve);
        });
    };

    return new AssetLoader();
})();




export default class Certificate {

    constructor(textures , text){
        this.textures = textures;
        this.text = text;
    }

    loadTextures(){

        var _to = [];

        for(var i = 0; i < this.textures.length; i++)
        {
            var img = new Image();
                img.src = this.textures[i].texture;
                img.position = this.textures[i].position
            _to.push(new Promise(function(resolve){
                img.onload = function () {
                    resolve(img)
                }
            }));
        }

        return Promise.all(_to);
    }

    image(){

        var to = [];
        for(var i = 0 ; i < this.textures.length; i ++){ to.push(this.textures[i].texture)}

        return AssetLoader.load.apply(AssetLoader , to).then(function(textures){
            return this.constructPIXI();
        }.bind(this))

    }

    constructPIXI(){

        const app = new window.PIXI.Application({
            width: 3508, height: 2480, backgroundColor: 0xFFFFFF, resolution: window.devicePixelRatio || 1,
        });

        app.ticker.add((delta) => {

        });

        document.getElementById('root').appendChild(app.view);

        const container = new window.PIXI.Container();

        app.stage.addChild(container);

        var textures = this.textures;


        for(var i=0; i < textures.length; i++)
        {
            let texture = new window.PIXI.Sprite(AssetLoader.getTextureFromSheet(textures[i].texture));
           // texture.position = textures[i].position
        }

        var text = this.text;

        for(var i=0; i < text.length; i++)
        {
            let pixitext = new window.PIXI.Text(text[i].isCapitalized ? String(text[i].text).toUpperCase() : String(text[i].text) , text[i].style);
            pixitext.position = text[i].position;

            if(text[i].isCentered)
            {
                pixitext.x = 3508/2 - pixitext.width/2 + text[i].centerOffset
            }

            container.addChild(pixitext)
        }



        return new Promise(function(resolve){

            setTimeout(function(){

                var image = app.renderer.plugins.extract.image(container , "image/png" , 1);

                image.onload = () => {
                    resolve(image)
                }
            } , 500)
        }.bind(this));
    }
}